import { render, staticRenderFns } from "./price.vue?vue&type=template&id=5397c165&scoped=true"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"
import style0 from "./price.vue?vue&type=style&index=0&id=5397c165&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397c165",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5397c165')) {
      api.createRecord('5397c165', component.options)
    } else {
      api.reload('5397c165', component.options)
    }
    module.hot.accept("./price.vue?vue&type=template&id=5397c165&scoped=true", function () {
      api.rerender('5397c165', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/product/price.vue"
export default component.exports